import { gql } from "graphql-request";

export const getFlagsQuery = gql`
  query ($customAttributes: JSON = "") {
    featureFlags {
      list(customAttributes: $customAttributes)
    }
  }
`;
